import PropTypes from 'prop-types';

const hexToRgba = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const GradientBackground = ({
  children,
  color1 = '#667eea',
  color2 = '#764ba2',
  diagonal = false,
  vertical = false,
  fadeToTransparent = false,
  className = '',
  style = {},
}) => {
  const direction = diagonal ? '45deg' : vertical ? 'to bottom' : 'to right';
  
  const gradientColors = fadeToTransparent
    ? `${hexToRgba(color1, 1)} 0%, ${hexToRgba(color1, 0.75)} 25%, ${hexToRgba(color2, 0.5)} 50%, ${hexToRgba(color2, 0.0)} 75%, ${hexToRgba(color2, 0)} 100%`
    : `${color1} 0%, ${color2} 33%`;

  const backgroundStyle = {
    background: `linear-gradient(${direction}, ${gradientColors})`,
  };

  return (
    <div style={{ ...backgroundStyle, ...style }} className={`w-full ${className}`}>
      {children}
    </div>
  );
};

GradientBackground.propTypes = {
  children: PropTypes.node,
  color1: PropTypes.string,
  color2: PropTypes.string,
  color3: PropTypes.string,
  diagonal: PropTypes.bool,
  vertical: PropTypes.bool,
  fadeToTransparent: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default GradientBackground;
